module.exports = __webpack_public_path__ + "img/roomcast-link.ee8a71cd.svg";